var map = {
	"./bar-chart.svg": 34975,
	"./battery.svg": 512,
	"./cog.svg": 10210,
	"./epod-pod.svg": 41185,
	"./myvuse-v.svg": 68309,
	"./star.svg": 79429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2273;